import { Review } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { useState, useEffect } from 'react';
import { useApiClient } from '@marageti/z4-lib';
import { useNavigate } from 'react-router-dom';

const useReview = (reviewId: string | undefined): [Review | undefined, boolean, ApiError | undefined] => {
  const navigate = useNavigate();
  const [review, setReview] = useState<Review>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ApiError>();
  const apiClient = useApiClient();

  const getAndSetReview = (id: string) => {
    setLoading(true);
    apiClient.reviewsClient
      .getReview(id)
      .then((r: Review) => setReview(r))
      .catch((e: ApiError) => {
        if (e.code === 401) navigate('/logout');
        if (e.code === 404) navigate('/404', { state: { error } });
        setReview(undefined);
        setError(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (reviewId) {
      getAndSetReview(reviewId);
    }
  }, [reviewId]);

  return [review, loading, error];
};

export default useReview;
